// stores/loader.ts
import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useLoaderStore = defineStore('loader', () => {
  const loading = ref(false);
  const message = ref<string | null>(null);

  function show(msg: string | null = null) {
    loading.value = true;
    message.value = msg;
  }
  function hide() {
    loading.value = false;
    message.value = null;
  }

  return { loading, message, show, hide };
});
